import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { XWareLogService } from './services/xware-log.service';
import { environment } from '../environments/environment';
import { CwMsalService } from './services/cw-msal.service';

@Component({
  selector: 'xware-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public isIframe: boolean;

  constructor(
    private logger: XWareLogService,
    private router: Router,
    private cwMsalService: CwMsalService
  ) {}

  ngOnInit(): void {
    this.logger.log('AppComponent> ngOnInit');
    const rooturi = environment.rootUri;
    if (rooturi) {
      sessionStorage.setItem('rooturi', rooturi);
    }
    //  This is to avoid reload during acquireTokenSilent() because of hidden iframe
    this.isIframe = window !== window.parent && !window.opener;

    if (sessionStorage.getItem('adType') !== 'gapi') {
      this.cwMsalService.checkAndSetActiveAccount();
    }
  }
}
